import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import caseCategoryService from "../services/case-category-service";

export const caseCategorySearchSchema = z.object({
	search: z.string().optional(),
	status: z.string().optional(),
	include: z.string().optional(),
	page: z.number().nullable().optional(),
	service_type: z.string().nullable().optional(),
	per_page: z.number().optional(),
	courtType: z.string().optional(),
	courtLevel: z.string().optional(),
});

export const caseCategorysQueryOptions = (search?: z.infer<typeof caseCategorySearchSchema>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["case_category", search],
		queryFn: () => caseCategoryService.list(transformSearch(search, ["status", "search", "courtType", "courtLevel", "service_type"])),
		...options,
	});
};

export const caseCategoryQueryOptions = (caseCategoryId: string) => {
	return queryOptions({
		queryKey: ["case_category", caseCategoryId],
		queryFn: () => caseCategoryService.findById(caseCategoryId),
	});
};

export const useCaseCategoryCreateMutation = (caseCategoryId?: string) => {
	return useMutation({
		mutationKey: ["case_category", caseCategoryId],
		mutationFn: caseCategoryService.create,
		meta: {
			successMessage: "Case category created successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["case_category"] }),
	});
};

export const useCaseCategoryMutation = (caseCategoryId?: string) => {
	return useMutation({
		mutationKey: ["case_category", caseCategoryId],
		mutationFn: caseCategoryService.upsert,
		meta: {
			successMessage: "Case category updated successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["case_category"] }),
	});
};
